import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class AssigneesColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Assignees
  declare readonly dataType: typeof MemexColumnDataType.Assignees
  declare readonly userDefined: false
}
